import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Jiahao = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4ee__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb4ee__a)">
            <path
              fillRule="evenodd"
              d="M22 22V6.998C22 5.894 22.91 5 24.015 5 25.09 5 26 5.894 26 6.998V22h15.002c1.104 0 1.998.91 1.998 2.015A2.005 2.005 0 0 1 41.002 26H26v15.002C26 42.106 25.09 43 23.985 43A2.005 2.005 0 0 1 22 41.002V26H6.998A2.011 2.011 0 0 1 5 23.985C5 22.91 5.894 22 6.998 22H22Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
